import { RecomendProducts } from "./productRecomendation";

export default RecomendProducts